import { Fragment } from 'react';
import styles from '../MaterialPreviewModal.module.css';
import { ClickDropdown, HoverDropdownItem, HoverDropdownDivider } from '../../../common/HoverDropdown';
import type { MaterialAction } from './useMaterialActions';

/** メニューでの表示順。区切り線を挟む位置ごとにまとめる */
const MENU_SECTIONS: Array<MaterialAction['group'][]> = [
  ['selection', 'ads', 'basic'],
  ['edit'],
  ['folder'],
  ['delete'],
];

/**
 * スマホ用フッター。useMaterialActions() が返した配列だけを描画する。
 * 可視条件・活性条件はここでは一切判断しない (= desktop と同じ配列を見る)。
 */
export function MaterialActionsMobile({ actions }: { actions: MaterialAction[] }) {
  const visible = actions.filter((a) => a.visible);
  // MENU_SECTIONS に並べたグループ順で項目を積む (配列の宣言順ではなくメニュー順)
  const sections = MENU_SECTIONS
    .map((groups) => groups.flatMap((group) => visible.filter((a) => a.group === group)))
    .filter((items) => items.length > 0);

  return (
    <div className={styles.footerMobile}>
      <ClickDropdown
        trigger={
          <button type="button" className="btn-modal">
            <img src="/navigation_menu.svg" alt="" style={{ width: '16px', height: '16px', marginRight: '6px' }} />
            操作メニュー
          </button>
        }
        position="top"
        align="left"
        minWidth="0"
      >
        {sections.map((items, index) => (
          <Fragment key={items[0].key}>
            {index > 0 && <HoverDropdownDivider />}
            {items.map((action) => (
              <HoverDropdownItem
                key={action.key}
                onClick={action.onClick}
                disabled={action.disabled}
                icon={<img src={action.icon} alt="" style={{ width: '16px', height: '16px' }} />}
              >
                {action.menuLabel ?? action.label}
              </HoverDropdownItem>
            ))}
          </Fragment>
        ))}
      </ClickDropdown>
    </div>
  );
}
